import { render } from "./NewsPageView.vue?vue&type=template&id=3f0dc008"
import script from "./NewsPageView.vue?vue&type=script&lang=js"
export * from "./NewsPageView.vue?vue&type=script&lang=js"

import "./NewsPageView.vue?vue&type=style&index=0&id=3f0dc008&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__